export const getUserDetails = () => {
  let data = localStorage.getItem("ufxDetails");
  if (data) return JSON.parse(data);
  return "";
};
